import antdData from 'antd/lib/locale-provider/ru_RU'
import localeData from 'react-intl/locale-data/ru'

const messages = {
  'topBar.issuesHistory': 'История заданий',
  'topBar.projectManagement': 'Управление проектом',
  'topBar.typeToSearch': 'Поиск...',
  'topBar.buyNow': 'Купить $26',
  'topBar.bitcoin': 'Биткоин',
  'topBar.profileMenu.hello': 'Привет',
  'topBar.profileMenu.billingPlan': 'Тарифный план',
  'topBar.profileMenu.role': 'Роль',
  'topBar.profileMenu.email': 'Емайл',
  'topBar.profileMenu.phone': 'Телефон',
  'topBar.profileMenu.editProfile': 'Редактировать профиль',
  'topBar.profileMenu.logout': 'Выйти',

  'menu.customers': 'Клиенты',
  'menu.orders': 'Заказы',
  'menu.settings': 'Настройки',
  'menu.promocodes': 'Промокоды',
  'menu.printDocuments': 'Печать документов',


  'main.delete': 'Удалить',
  'main.save': 'Сохранить',
  'main.cancel': 'Отмена',
  'main.edit': 'Редактировать',
  'main.view': 'Просмотр',
  'main.add': 'Добавить',

  'erp.prot': 'Белки',
  'erp.fat': 'Жиры',
  'erp.carb': 'Углеводы',
  'erp.dish': 'Блюдо',
  'erp.meal': 'Прием',
  'erp.weightG': 'Вес (г)',
  'erp.cf': 'Кф',
  'erp.coefficient': 'Коэффициент',
  'erp.group': 'Группа',
  'erp.positions': 'Позиции',
  'erp.netto': 'Нетто',
  'erp.brutto': 'Брутто',
  'erp.unit': 'Ед. изм.',
  'erp.name': 'Название',
  'erp.mainGroup': 'Главная группа',


  'erp.ingredientGroup': 'Группа ингредиентов',
  'erp.ingredient': 'Ингредиент',
  'erp.techcard': 'Техкарта',
  'erp.menuTemplate': 'Шаблон меню',

  'erp.technologyСooking': 'Технология приготовления',
  'erp.semiproducts': 'Полуфабрикаты',
  'erp.semiproduct': 'Полуфабрикат',

  'erp.ingredientGroups': 'Группы ингредиентов',
  'erp.ingredients': 'Ингредиенты',
  'erp.techcards': 'Техкарты',
  'erp.menuTemplates': 'Шаблоны меню',
  'erp.menuCalendar': 'Календарь меню',

  'erp.allGroups': 'Все группы',
  'erp.allIngredients': 'Все ингредиенты',
  'erp.allTechcards': 'Все техкарты',
  'erp.allTemplates': 'Все шаблоны',

  'erp.newGroup': 'Новая группа',
  'erp.newIngredient': 'Новый ингредиент',
  'erp.newTechcard': 'Новая техкарта',
  'erp.newTemplate': 'новый шаблон',

  'erp.searchView': 'Поиск / Просмотр',

  'erp.title.createIngredientGroup': 'Создание группы ингредиентов',
  'erp.title.createIngredient': 'Создание ингредиента',
  'erp.title.createTechcard': 'Создание техкарты',
  'erp.title.createTemplate': 'Создание шаблонв меню',

  'erp.title.editingIngredientGroup': 'Редактирование группы ингредиентов',
  'erp.title.editingIngredient': 'Редактирование ингредиента',
  'erp.title.editingTechcard': 'Редактирование техкарты',
  'erp.title.editingTemplate': 'Редактирование шаблона меню',
}

export default {
  locale: 'ru-RU',
  antdData,
  localeData,
  messages,
}
